export default __webpack_public_path__ + "static/media/whatsapp.f5d0b603.png";